import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { CSSProperties } from "@mui/styles";
import styled from "styled-components";

export const StrategyDialogDiv = styled.div`
    background: ${UIStyleConstants.WHITE_COLOR};
    border: 1px solid ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
    box-sizing: border-box;
    box-shadow: 0px 4px 16px -4px ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
    border-radius: 8px;
    position: absolute;
    z-index: 10;
`;

export const StrategyDialogContent = styled.div`
  position: relative;
  padding: 8px 20px 4px;

  min-width: 300px;

  .StrategyDialog-close {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 0;
    padding: 0;
  }

  .StrategyDialog-title {
    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

    text-align: center;
    padding: 16px 0;

    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
  }

  .StrategyDialog-select,
  .Strategy-error {
    width: 196px;

    &.StrategyDialog-select-error {
      margin-bottom: 4px;

      .MuiOutlinedInput-input {
        color: ${UIStyleConstants.RED_COLOR};
      }
    }

    .MuiOutlinedInput-input {
      height: auto;
      border: solid 1px ${UIStyleConstants.GRAY_LIGHTER_COLOR};
      padding: 6px 12px;

      color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 140%;
    }
  }

  .StrategyDialog-table {
    .MuiTableCell-root {
      padding: 8px 0;

      color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 140%;
      border-bottom: 1px solid ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};

      &.MuiTableCell-head {
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 140%;
        color: ${UIStyleConstants.GRAY_LIGHT_COLOR};
        border-bottom: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
      }
    }

    .StrategyDialog-default__text {
      color ${UIStyleConstants.GREEN_COLOR};;

      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 140%;
      margin-left: 20px;
    }
  }
`;

export const TitleDiv = styled("div")<{
    content?: string;
    isCollapsed: boolean;
    isNormal: boolean;
    styles: CSSProperties;
}>`
    background: transparent;
    min-width: 100px;
    display: flex;
    padding-bottom: 5px;
    padding-right: 24px;

    ${(props) =>
        !props.isCollapsed &&
        `
		position: absolute;
		top: -22px;
		left: 2px;
	`}
    .InlineEdit {
        min-width: 100px;
        max-width: 100%;
        overflow: hidden;
        height: 20px;
        ${(props) => (props.isNormal ? `cursor: text` : "cursor: default")};
    }

    .MuiTypography-body1 {
        line-height: 1;
    }

    .InlineEdit-label {
        padding: 0 !important;
        max-width: 100%;
        border-bottom: none;

        &:hover {
            background: transparent;
            border-bottom: none;
        }
    }

    .InlineEdit-input {
        position: relative;
        display: inline-block;

        .MuiInputBase-input {
            padding: 0;
            max-width: 100%;
            border: none;
            position: absolute;
            top: 0;
            left: 0;
        }

        &::before {
            content: "${(props) => props.content || ""}";
            font-size: 15px;
            line-height: 25px;
            display: block;

            font-style: normal;
            font-weight: 600;
            padding: 0;
            letter-spacing: 0.5px;
            opacity: 0;
        }
    }

    .InlineEdit-label,
    .InlineEdit-input .MuiInputBase-input {
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        ${(props) => `
			color: ${props.styles.color || "" + UIStyleConstants.GRAY_COLOR};
			font-size: ${props.styles.fontSize || "12px"};
			letter-spacing: ${props.styles.letterSpacing || "0.5px"};
		`}
    }
`;

export const StyledIconButton = styled.div`
    display: flex;
    background: ${UIStyleConstants.WHITE_COLOR};
    cursor: pointer;

    width: 31px;
    height: 30px;
    border-left: solid 1px ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};

    align-items: center;
    justify-content: center;

    &.stack-move {
        position: relative;

        img {
            opacity: 0.5;
        }

        &::after {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            content: "";
            height: 100%;
        }
    }

    &:first-child {
        width: 30px;
        border-left: none;
    }
`;

export const OnDiv = styled.div`
  color ${UIStyleConstants.GREEN_COLOR};;

  font-style: normal;
  font-weight: bold;
  font-size: 8px;
  line-height: 140%;
`;

export const OffDiv = styled.div`
    color: ${UIStyleConstants.GRAY_LIGHT_COLOR};

    font-style: normal;
    font-weight: bold;
    font-size: 8px;
    line-height: 140%;
`;

export const DraggableItemDiv = styled.div<{ isDragging?: boolean }>`
    border: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
    border-radius: 5px;
    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
    cursor: pointer;

    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    margin-bottom: 10px;
    padding: 8px;

    ${(props) =>
        props.isDragging
            ? `
			padding: 5px !important;
		`
            : `
			height: 28px;
			width: 28px;
		`};
    @media (min-width: 1366px) {
        height: auto;
        width: auto;
        justify-content: flex-start;
    }

    > img {
        margin-right: 0;
        transform: scale(0.88);
        @media (min-width: 1366px) {
            margin-right: 8px;
            transform: scale(1);
        }
    }

    .favorite-icon {
        position: absolute;
        opacity: 0;
        top: 50%;
        transform: translateY(-50%);
        right: 12px;
        display: flex;
    }

    ${(props) =>
        !props.isDragging &&
        `
		&:hover .favorite-icon {
			opacity: 1;
		}
	`}
    span {
        display: none;
        @media (min-width: 1366px) {
            display: inline;
        }
    }
`;
